import { CoverageItem } from '@/components/shared/StyledElements';
import { useSectionEventOnViewportEntrance } from '@/hooks/useSectionEventOnViewportEntrance';
import { Box } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import React from 'react';
import styled from 'styled-components';
import type { CoverageSectionProps } from './Coverage';
import { CoverageSection } from './Coverage';
import { yeahReallyImg } from './assets/coverages/overall';
import type { PriceType } from './types';

export interface OverallCoveragesProps extends CoverageSectionProps {
  priceType: PriceType;
}

const StyledCoverageItem = styled(CoverageSection)`
  ${MEDIA_QUERIES.tabletAndDesktop`
        ${CoverageItem} {
            &:nth-of-type(4) {
                margin-right: 88px;
                margin-left: auto;
            }
            &:last-of-type {
                margin-right: auto;
                margin-left: 88px;
            }
        }
    `}
`;

export const YeahReally = styled(Box).attrs({
  as: 'img',
  src: yeahReallyImg.src,
  alt: 'yeah really',
})`
  position: absolute;
  top: -40px;
  right: -90px;

  ${MEDIA_QUERIES.upToDesktop`
        display: none;
    `}
`;

export enum FixedPriceCoverage {
  ClaimsResolution = 'claims_resolution',
  FairPrice = 'fair_price',
  Trees = 'trees',
  EmergencyCrash = 'emergency_crash',
  RoadsideAssistance = 'roadside_assistance',
}

const OverallCoverages: React.FC<OverallCoveragesProps> = ({ priceType = 'fixed', ...restProps }) => {
  const intersectionRef = useSectionEventOnViewportEntrance({
    sectionName: 'overallCoverages',
    page: 'car',
    position: 2,
  });
  let coverageSectionStyle = {};
  if (priceType === 'ppm') {
    coverageSectionStyle = {
      containerWidth: 1041,
      itemWidth: [210, 287],
    };
  }

  return <StyledCoverageItem {...restProps} {...coverageSectionStyle} ref={intersectionRef} />;
};

export default React.memo(OverallCoverages);
